import { useState } from "react";

export default function DisclaimerBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="mx-auto max-w-6xl px-4 py-3">
        <div className="flex items-start gap-3">
          <svg 
            className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
            />
          </svg>
          <p className="text-sm text-amber-900 flex-1">
            <strong>Disclaimer:</strong> Some content on this site was generated with AI assistance and reviewed for accuracy. 
            This site provides educational estimates only — not tax, legal, or financial advice. 
            Always consult a qualified CPA, Enrolled Agent, or tax professional for personalized guidance.
          </p>
          <button
            onClick={() => setIsVisible(false)}
            className="text-amber-600 hover:text-amber-800 flex-shrink-0 transition-colors"
            aria-label="Close disclaimer"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
